import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trips-container" }
const _hoisted_2 = { class: "trips-section" }
const _hoisted_3 = {
  key: 1,
  class: "no-trips"
}
const _hoisted_4 = { class: "trips-section" }
const _hoisted_5 = {
  key: 1,
  class: "no-trips"
}
const _hoisted_6 = {
  key: 0,
  class: "pagination-container"
}

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { DateTime } from 'luxon'

import { EvCarProfileFull } from '@/models/evCarProfile'

import { useEvCarsStore } from '@/store/ev-vehicles'

import Loader from '@/components/Loader.vue'
import CommonError from '@/components/CommonError.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleTripsSection',
  props: {
    vehicle: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

const evCarsStore = useEvCarsStore()

const tripsModule = computed(() => evCarsStore.evVehicleTrips[props.vehicle.id])

const error = computed(() => tripsModule.value?.error)
const isLoading = computed(() => tripsModule.value?.isLoading)
const allTrips = computed(() => tripsModule.value?.data || [])
const meta = computed(() => tripsModule.value?.meta)

// Pagination state
const currentPage = ref(1)
const perPage = ref(20)
const totalTrips = computed(() => meta.value?.total || allTrips.value.length)

// Computed properties for filtering trips
const ongoingTrips = computed(() => {
  return allTrips.value
    .filter(trip =>
      ['ongoing', 'accepted', 'reserved', 'pending'].includes(trip.status)
    )
    .sort(
      (a, b) =>
        new Date(b.start_date).getTime() - new Date(a.start_date).getTime()
    )
})

const completedTrips = computed(() => {
  const completed = allTrips.value.filter(trip => trip.status === 'finished')

  return completed.sort(
    (a, b) =>
      new Date(b.start_date).getTime() - new Date(a.start_date).getTime()
  )
})

// Helper functions
const getRenterName = (trip: any): string => {
  if (trip.renter) {
    return `${trip.renter.first_name || ''} ${trip.renter.last_name ||
      ''}`.trim()
  }
  return 'Unknown'
}

const getVehicleInfo = (trip: any): string => {
  if (trip.ev_car_profile) {
    return trip.ev_car_profile.model_name || 'Unknown'
  }
  return 'Unknown'
}

const getPlateNumber = (trip: any): string => {
  return trip.ev_car_profile?.plate_number || 'Unknown'
}

const formatDateTime = (dateString: string | null): string => {
  if (!dateString) return '-'
  try {
    return DateTime.fromISO(dateString).toLocaleString({
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return 'Invalid date'
  }
}

const formatCurrency = (amount: number | string | null): string => {
  if (amount === null || amount === undefined) return '-'

  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(numericAmount)) return '-'

  return `₼ ${numericAmount.toFixed(2)}`
}

const handleTripClick = (trip: any) => {
  router.push(`/ev-trips/${trip.id}`)
}

const handlePageChange = async (page: number) => {
  currentPage.value = page
  await getVehicleTrips(page)
}

const handlePerPageChange = async (size: number) => {
  perPage.value = size
  currentPage.value = 1
  await getVehicleTrips(1)
}

const getVehicleTrips = async (page: number = currentPage.value) => {
  evCarsStore.getEvVehicleTrips(props.vehicle.id, {
    page,
    perPage: perPage.value,
    sortBy: 'created_at',
    sortDirection: 'desc',
  })
}

onMounted(async () => {
  await getVehicleTrips()
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: getVehicleTrips
      }, null, 8, ["errorMessage"]))
    : (isLoading.value)
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "section-title" }, "ONGOING TRIPS", -1)),
                (ongoingTrips.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_table, {
                      key: 0,
                      data: ongoingTrips.value,
                      style: {"width":"100%"},
                      class: "trips-table",
                      onRowClick: handleTripClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "Renter",
                          "min-width": "180"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(getRenterName(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Start date",
                          "min-width": "160"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(formatDateTime(scope.row.start_date)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "End date",
                          "min-width": "120"
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createElementVNode("span", { class: "empty-field" }, "-", -1)
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Make and Model",
                          "min-width": "150"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(getVehicleInfo(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Plate number",
                          "min-width": "120"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(getPlateNumber(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Trip Total",
                          "min-width": "120"
                        }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createElementVNode("span", { class: "empty-field" }, "-", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[4] || (_cache[4] = [
                      _createElementVNode("p", null, "No ongoing trips found", -1)
                    ])))
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "section-title" }, "COMPLETED TRIPS", -1)),
                (completedTrips.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_el_table, {
                      key: 0,
                      data: completedTrips.value,
                      style: {"width":"100%"},
                      class: "trips-table",
                      onRowClick: handleTripClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "Renter",
                          "min-width": "180"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(getRenterName(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Start date",
                          "min-width": "160"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(formatDateTime(scope.row.start_date)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "End date",
                          "min-width": "160"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(formatDateTime(scope.row.end_date)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Make and Model",
                          "min-width": "150"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(getVehicleInfo(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Plate number",
                          "min-width": "120"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(getPlateNumber(scope.row)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Trip Total",
                          "min-width": "120"
                        }, {
                          default: _withCtx((scope) => [
                            _createTextVNode(_toDisplayString(formatCurrency(scope.row.total_amount)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[6] || (_cache[6] = [
                      _createElementVNode("p", null, "No completed trips found", -1)
                    ])))
              ]),
              (totalTrips.value > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_el_pagination, {
                      "current-page": currentPage.value,
                      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                      "page-size": perPage.value,
                      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event)),
                      total: totalTrips.value,
                      layout: "total, sizes, prev, pager, next",
                      "page-sizes": [10, 20, 50, 100],
                      "hide-on-single-page": false,
                      onCurrentChange: handlePageChange,
                      onSizeChange: handlePerPageChange,
                      background: ""
                    }, null, 8, ["current-page", "page-size", "total"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
}
}

})